import { neutralColors, secondaryColors } from '../tokens/color';

export const enecoChatbotColors = {
  botMessageBubbleBackground: neutralColors.neutral100,
  userMessageBubbleBackground: secondaryColors.accentGreen100,
  failedUserMessageBackground: secondaryColors.orange100,
  backgroundChatHeader: secondaryColors.accentGreen700,
  backgroundSendBox: neutralColors.neutral300,
};
